import { Component, Input, OnInit } from '@angular/core';
import { JobService } from 'src/app/timeline-skip/services/job.service';
import { DashboardStateServiceService } from '../../services/dashboard-state-service.service';
import { catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';
import moment from 'moment';

@Component({
    selector: 'app-jobs-this-week-graph',
    templateUrl: './jobs-this-week-graph.component.html',
    styleUrls: ['./jobs-this-week-graph.component.scss'],
    standalone: false
})
export class JobsThisWeekGraphComponent implements OnInit {
  @Input() startDate: string;
  @Input() endDate: string;

  dataBar: any[] = [];
  loaded: boolean = false;

  view: any[] = [];
  gradient: boolean = false;
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  showYAxisLabel: boolean = true;
  yAxisLabel: string = 'Jobs';

  colorScheme = {
    domain: ['#006498']
  };

  constructor(
    private jobService: JobService,
    private dashboardStateService: DashboardStateServiceService
  ) { }

  ngOnInit(): void {
    this.dashboardStateService.$datesChanged.subscribe(() => {
      this.loadContent();
    });

    this.loadContent();
  }

  loadContent(): void {
    const start = moment(this.startDate);
    const end = moment(this.endDate);

    if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
      this.dataBar = [];
      this.loaded = true;
      return;
    }

    this.jobService.getJobsByDateRange(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
      .pipe(take(1))
      .pipe(catchError(() => of([])))
      .subscribe((jobs) => {
        const days: { key: string, label: string }[] = [];
        const counts: { [key: string]: number } = {};

        const day = start.clone();
        while (day.isSameOrBefore(end, 'day')) {
          const key = day.format('YYYY-MM-DD');
          counts[key] = 0;
          days.push({ key, label: day.format('DD/MM') });
          day.add(1, 'day');
        }

        jobs.forEach((job) => {
          const key = moment(job.date).format('YYYY-MM-DD');
          if (counts[key] !== undefined) {
            counts[key]++;
          }
        });

        this.dataBar = days.map((d) => ({ name: d.label, value: counts[d.key] }));
        this.loaded = true;
      });
  }

}
